export const Airport = {
    loaded: 'airport.loaded',
    active: 'airport.active',
    inactive: 'airport.inactive',
};

export const Map = {
    open: 'map.open',
    close: 'map.close',
};

export const Marker = {
    change: 'marker.change',
};
